// extracted by mini-css-extract-plugin
export default {"v-application":"Footer_v-application_kMN7j","text-h1":"Footer_text-h1_d_mti","text-h2":"Footer_text-h2_m7Y4U","footer":"Footer_footer_ogIiA","cols":"Footer_cols_jDBpk"};